/**
 * Utility for managing user's preferred zip code across widgets
 */

const ZIP_CODE_STORAGE_KEY = 'userPreferredZipCode'
const DEFAULT_ZIP_CODE = '94102' // San Francisco

/**
 * Get the user's preferred zip code
 * Returns the last saved zip code, or default if none exists
 */
export const getPreferredZipCode = (): string => {
  try {
    const stored = localStorage.getItem(ZIP_CODE_STORAGE_KEY)
    return stored || DEFAULT_ZIP_CODE
  } catch (error) {
    console.error('Error reading preferred zip code:', error)
    return DEFAULT_ZIP_CODE
  }
}

/**
 * Save the user's preferred zip code
 * This will be used as the default for new widgets
 */
export const savePreferredZipCode = (zipCode: string): void => {
  try {
    if (zipCode && zipCode.trim()) {
      localStorage.setItem(ZIP_CODE_STORAGE_KEY, zipCode.trim())
      console.log('Saved preferred zip code:', zipCode)
    }
  } catch (error) {
    console.error('Error saving preferred zip code:', error)
  }
}

/**
 * Clear the user's preferred zip code (resets to default)
 */
export const clearPreferredZipCode = (): void => {
  try {
    localStorage.removeItem(ZIP_CODE_STORAGE_KEY)
  } catch (error) {
    console.error('Error clearing preferred zip code:', error)
  }
}

/**
 * Get the default zip code (fallback)
 */
export const getDefaultZipCode = (): string => {
  return DEFAULT_ZIP_CODE
}












